import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=0b0f53f0&scoped=true"
import script from "./AuditLog.vue?vue&type=script&lang=js"
export * from "./AuditLog.vue?vue&type=script&lang=js"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=0b0f53f0&prod&scoped=true&lang=css"
import style1 from "./AuditLog.vue?vue&type=style&index=1&id=0b0f53f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0f53f0",
  null
  
)

export default component.exports